import classnames from 'classnames';
import React from 'react';

import { CategoryItem } from '~/components/side-navigation';
import { Tooltip, TooltipTrigger } from '~/components/tooltip/Tooltip';

import styles from './NavItem.module.scss';

export type NavItemProps = {
  item: CategoryItem;
  activeSubKey?: string;
  sideBarExpanded: boolean;
};

export const NavItem = ({
  item,
  activeSubKey,
  sideBarExpanded,
}: NavItemProps) => {
  return (
    <Tooltip
      label={item.label}
      disabled={sideBarExpanded}
      trigger={TooltipTrigger.Hover}
      placement="right"
    >
      <button
        key={item.key}
        className={classnames(styles.subItem, {
          [styles.isActive]: activeSubKey === item.key,
          [styles.sideBarExpanded]: sideBarExpanded,
        })}
        data-testid={`subitem-${item.key}`}
        onClick={() => {
          item.onClick?.(item);
        }}
      >
        {item.icon && (
          <>
            <span className={styles.iconWrapper}>{item.icon}</span>
            {sideBarExpanded && (
              <span className={styles.mainLabel}>{item.label}</span>
            )}
          </>
        )}
        {!item.icon && (
          <span className={styles.mainLabel}>
            {sideBarExpanded ? item.label : item.label.charAt(0).toUpperCase()}
          </span>
        )}
        {sideBarExpanded && item.badge}
      </button>
    </Tooltip>
  );
};

NavItem.styles = styles;
